import {
  CREATE_BENEFIT_GROUP_CATEGORY,
  CREATE_BENEFIT_GROUP_CATEGORY_SUCCESS,
  CREATE_BENEFIT_GROUP_CATEGORY_ERROR,
  CREATE_BENEFIT_GROUP_CATEGORY_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateBenefitGroupCategory = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BENEFIT_GROUP_CATEGORY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_BENEFIT_GROUP_CATEGORY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_BENEFIT_GROUP_CATEGORY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CREATE_BENEFIT_GROUP_CATEGORY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateBenefitGroupCategory;
